import { render } from "./AppAvatarImg.vue?vue&type=template&id=b4630a2c&scoped=true"
import script from "./AppAvatarImg.vue?vue&type=script&lang=js"
export * from "./AppAvatarImg.vue?vue&type=script&lang=js"

import "./AppAvatarImg.vue?vue&type=style&index=0&id=b4630a2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4630a2c"

export default script